const key = 'autopaste-enabled';

export const setAutopasteLocalStorage = (isEnabled: boolean) => {
  localStorage.setItem(key, String(isEnabled));
};

export const getAutopasteLocalStorage = () => {
  return localStorage.getItem(key) === 'true';
};
